var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
let TrafficLight = class TrafficLight extends Vue {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.isLoading = false;
    }
    get modifier() {
        return this.disabled ? 'disabled' : 'enabled';
    }
    setDisabledState() {
        this.disabled = true;
    }
    setEnabledState() {
        this.disabled = false;
    }
    setLoadingStateOn() {
        this.isLoading = true;
    }
    setLoadingStateOff() {
        this.isLoading = false;
    }
    onClickTrafficLight() {
        if (this.disabled) {
            return;
        }
        const event = {
            setDisabledState: () => this.setDisabledState(),
            setEnabledState: () => this.setEnabledState(),
            setLoadingStateOn: () => this.setLoadingStateOn(),
            setLoadingStateOff: () => this.setLoadingStateOff(),
        };
        this.$emit('trafficLightClicked', event);
    }
};
__decorate([
    Prop({ default: 'green' }),
    __metadata("design:type", String)
], TrafficLight.prototype, "color", void 0);
TrafficLight = __decorate([
    Component({})
], TrafficLight);
export default TrafficLight;
